import FJFontManager from '../core/font/FJFontManager';

const FJAIRemixUtil = {
    getFontFamily: function (fontFamily, options = {}) {
        const { textLanguage } = options;
        const fontList = FJFontManager.fontItems();
        const needDealLanguageList = ['japanese', 'traditional chinese', 'simplified chinese'];

        if (!needDealLanguageList.includes(textLanguage)) {
            return fontFamily;
        }

        const fontInfo = {
            'simplified chinese': {
                bold: 'Chuangketie Jingangti',
                'modern(sans)': 'Notosanshans',
                'traditional(serif)': 'Fangzhengshusong Jianti',
                handwriting: 'Zhaizaijiazidongbi',
                funny: 'Maokenshijinhei',
            },
            'traditional chinese': {
                bold: 'Wtcmt',
                'modern(sans)': 'Taipeisanstcbeta',
                'traditional(serif)': 'Genyo Font Master Tw',
                handwriting: 'Chenyuluoyan Thin',
                funny: 'Wtzyt',
            },
            japanese: {
                bold: 'Genreipopple',
                'modern(sans)': 'Genyog Font Master Jp',
                'traditional(serif)': 'Genyo Font Master Jp',
                handwriting: 'Xiaolaisc',
                funny: 'Yusei Magic',
            },
        };

        try {
            const useFontCategory = fontList.find(
                item => !!item.items.find(inner => inner.name === fontFamily),
            ).category;
            if (useFontCategory) {
                return fontInfo[textLanguage][useFontCategory] || fontFamily;
            } else {
                return fontFamily;
            }
        } catch (e) {
            return fontFamily;
        }
    },
};

export default FJAIRemixUtil;
